<template>
	<div id="app">
		<NuxtLayout :name="$route.path.includes('customs-privacy') ? 'customs-privacy' : 'default'">
			<NuxtPage />
		</NuxtLayout>
	</div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useNuxtApp } from '#imports';

const { $plausible } = useNuxtApp();

onMounted(() => {
	$plausible();
});
</script>

<style lang="scss">
@import '~/assets/design';
</style>
